export default __webpack_public_path__ + "static/media/firefox.2cb60328.png";